<template>
  <div>

    <b-table
      narrowed
      :data="$store.state.evaluation.saleCompGroup.saleComps"
      :opened-detailed="defaultOpenedDetails"
      detailed
      detail-key="id"
      :row-class="(row, index) => row.include === false && 'is-excluded'"
      style="font-size: .90rem"
    >
      >

      <template slot-scope="props">

        <b-table-column
          field="photo"
          label=""
        >
          <p class="image is-96x96 has-text-centered">
            <img
              class="compPic"
              v-bind:src="props.row.photoURLs[0]"
            >
            <a
              class="is-size-7"
              @click="details(props.row.id)"
              target="_blank"
            >details</a>
            &nbsp;
            <a
              class="is-size-7"
              :href="mapUrl(props.row.street, props.row.city, props.row.state, props.row.zip)"
              target="_blank"
            >map</a>
          </p>
        </b-table-column>

        <b-table-column
          field="street"
          label="Address"
          sortable
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          <span>
            <div>{{ props.row.street }}</div>
            <div class="is-size-7">{{ props.row.city }}, {{ props.row.state }}, {{ props.row.zip }}</div>
          </span>
        </b-table-column>

        <b-table-column
          field="subdivision"
          label="Subdivision"
          sortable
          :visible="$store.state.evaluation.compDataSource != 'Discovery'"
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ props.row.subdivision }}
        </b-table-column>

        <b-table-column
          field="beds"
          label="Beds"
          numeric
          sortable
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ props.row.beds }}
        </b-table-column>

        <b-table-column
          field="baths"
          label="Baths"
          numeric
          sortable
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ props.row.baths }}
        </b-table-column>

        <b-table-column
          field="garage"
          label="Garage"
          numeric
          sortable
          :visible="$store.state.evaluation.compDataSource != 'Discovery'"
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ props.row.garage }}
        </b-table-column>

        <b-table-column
          field="yearBuilt"
          label="Built"
          numeric
          sortable
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ props.row.yearBuilt }}
        </b-table-column>

        <b-table-column
          field="sqft"
          label="Sqft"
          numeric
          sortable
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ props.row.sqft }}
        </b-table-column>

        <b-table-column
          field="DOM"
          label="DOM"
          numeric
          :visible="$store.state.evaluation.compDataSource != 'Discovery'"
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ props.row.daysOnMarket }}
        </b-table-column>

        <b-table-column
          field="priceListed"
          label="List $"
          numeric
          sortable
          :visible="$store.state.evaluation.compDataSource != 'Discovery'"
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ props.row.priceListed | number(0) }}
        </b-table-column>

        <b-table-column
          field="dateSold"
          label="Sold date"
          sortable
          :visible="$store.state.evaluation.compDataSource == 'Discovery'"
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ props.row.dateSold | date }}
        </b-table-column>

        <b-table-column
          field="priceSold"
          label="Sold $"
          numeric
          sortable
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ props.row.priceSold | number(0) }}
        </b-table-column>

        <b-table-column
          field="pricePerSqft"
          label="$/sqft"
          numeric
          sortable
          :style="{ 'text-decoration': isStrikeThrough(!props.row.include) }"
        >
          {{ (props.row.priceSold / props.row.sqft) | number(0) }}
        </b-table-column>

        <b-table-column
          field="include"
          label="Include?"
          numeric
        >
          <div @click="includeClick($store.state.evaluation, props.row, !props.row.include)">
            <b-checkbox v-model="props.row.include"></b-checkbox>
          </div>
        </b-table-column>

      </template>

      <template
        slot="detail"
        slot-scope="props"
      >

        <div
          class="notification"
          v-if="$store.state.evaluation.compDataSource != 'Discovery'"
        >
          <nav class="level">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Market</p>
                <p class="subtitle">{{ props.row.market }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">MLS#</p>
                <p class="subtitle">{{ props.row.mlsNumber }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Type</p>
                <p class="subtitle">{{ props.row.listingType }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">HOA</p>
                <p class="subtitle">{{ props.row.annualHOA | currency(0) }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Tax</p>
                <p class="subtitle">{{ props.row.annualPropertyTax | currency(0) }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Sold</p>
                <p class="subtitle">{{ props.row.dateSold | date }}</p>
              </div>
            </div>
          </nav>
          <small>{{ props.row.descriptionPublic }}</small>
        </div>

        <div class="notification">
          <div class="container is-fluid">
            <div class="columns is-multiline">
              <div
                class="column is-one-third"
                v-for="photoUrl in props.row.photoURLs"
                :key="photoUrl"
              >
                <figure class="image is-3by2">
                  <img v-bind:src="photoUrl">
                </figure>
              </div>
            </div>
          </div>
        </div>

      </template>

    </b-table>

  </div>
</template>

<script>
import store from "@/store";

export default {
  components: {},

  data() {
    return {
      isPhotosOpen: false,
      isDetailsOpen: false,
      defaultOpenedDetails: []
    };
  },

  methods: {
    includeClick(evaluation, saleComp, include) {
      var propertyId = evaluation.propertyId;
      var evaluationId = evaluation.id;
      var saleCompId = saleComp.id;
      store.dispatch("includeExcludePropertyEvaluationSaleComp", {
        propertyId,
        evaluationId,
        saleCompId,
        include
      });
    },

    isStrikeThrough(value) {
      if (value == true) return "line-through";
      else return "";
    },

    isDimmer(value) {
      if (value == true) return "brightness(35%)";
      else return "brightness(100%)";
    },

    mapUrl(address, city, state, zip) {
      return `https://www.google.com/maps/place/${address},${city},${state},${zip}`;
    },

    details(id) {
      var index = this.defaultOpenedDetails.indexOf(id);
      console.log("index", index);
      if (index == -1) this.defaultOpenedDetails.push(id);
      else this.defaultOpenedDetails.splice(index, 1);
    }
  }
};
</script>

<style>
tr.is-excluded {
  background: hsl(0, 0%, 98%);
  color: hsl(0, 0%, 48%);
}
img.compPic {
  display: block;
  max-width: 96px;
  max-height: 80px;
  width: auto;
  height: auto;
}
</style>
